export const LOADING_STARTED = 'LOADING_STARTED';
export const FLOW_TEMPLATES_LOADED = 'FLOW_TEMPLATES_LOADED';
export const REMOVE_FLOW_TEMPLATE = 'REMOVE_FLOW_TEMPLATE';
